import type { StyleProp, ViewStyle } from '../web';

/**
 * Get the breakpoints from the biggest to the smallest
 */
export function getSortedBreakpoints(breakpoints: {
    [breakpoint: number]: StyleProp<ViewStyle> | 'hidden' | 'visible';
}): string[] {
    return Object.keys(breakpoints).sort((a, b) =>
        Number.parseFloat(a) - Number.parseFloat(b) > 0 ? -1 : 1
    );
}
